<template lang="pug">
.goal-setter.d-flex.flex-column.h-100.scrollable
  .sticky-top.bg-white
    .custom-header.d-flex
      //- CustomTab.flex-fill(
      //-   :tabItems='tabItems'
      //-   v-model='selectedTab'
      //- )
      button.transparent-button.no-scaling.ml-auto.mb-auto(@click='$emit(`closeButtonClicked`)')
        i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')
    .px-4
      .text-large ราคาขายสินค้าและค่าคอมมิชชั่น
    .d-flex.align-items-end.px-4.py-4.mb-3
      .text-right
        .text-small.mb-2 ระบุเป้าหมายที่ต้องการบันทึก
        input.border.rounded.text-right.py-4.px-4.text-xlarge(
          type="number" v-model.number="goal"
          style='width: 100%'
        )
      button.btn.btn-upa-secondary.h-50.flex-fill.ml-3(@click='$emit(`saveButtonClicked`)')
        | บันทึก
    hr.m-0
  .py-2.px-4
    CustomTable(
      :columns='tableColumns'
      :data='tableData'
      :showIndexes='true'
      :itemClickable='false'
    )
      //- @itemClicked='showModal'

</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

export default {
  data: () => ({
    tableData: [],
    tableColumns: {
      month: {
        title: 'เดือน',
        align: 'left',
      },
      goal: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
      },
    },

    selectedItem: {},

    goal: 900000.09,
  }),
  methods: {
    async loadData() {
      this.isLoading = true;

      // const res = await this.$api.product.productStat(this.product.id, this.customer.id);
      // if (res.status === 200) {
      //   this.tableData = res.data.data;
      // }
      this.tableData = [
        {
          month: 'มกราคม',
          goal: 69000.46,
        },
        {
          month: 'กุมภาพันธ์',
          goal: 70000,
        },
        {
          month: 'มีนาคม',
          goal: 73000,
        },
        {
          month: 'เมษายน',
          goal: 69000.46,
        },
        {
          month: 'พฤษภาคม',
          goal: 73000,
        },
      ];

      this.isLoading = false;
    },
  },
  mounted() {
    this.loadData();
  },
  components: {
    CustomerCompactDetailHeader,
  },
};
</script>

<style lang="scss">
// .goal-setter {}
.custom-header {
  background: #fff;
  // padding-bottom: 8px;
}
</style>
